/**
 * Constantes y configuración globales de la aplicación
 */

/**
 * URL base para el servidor de la API
 * @default 'http://localhost:8080'
 */
export const API_BASE_URL =
  (import.meta as any).env?.VITE_API_BASE_URL || "http://gateway-nom-develop:7940";

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  GUIDES: "/api/guides",
  WEIGHTINGS: (guideCode: string) =>
    `${API_ENDPOINTS.GUIDES}/${guideCode}/weightings`,
} as const;

export const GUIDE_KEYS = {
  I: "GUIA_I",
  II: "GUIA_II",
  III: "GUIA_III",
} as const;

/**
 * Rutas de la aplicación
 */

export const RUTAS = {
  ROOT: "/",
  GUIA_I: "/guia-1",
  GUIA_II: "/guia-2",
  GUIA_III: "/guia-3",
  ACCESO: "/acceso",
  BIENVENIDO: "/bienvenido",
  TERMINAR: "/terminado",
  FORMULARIO: "/formulario",
  ACCESODENEGADOS: "/no-autorizado",
} as const;

/**
 * Texto de proceso de la aplicación
 */
export const SIDEBAR_DESCRIPTIONS: Record<string, string> = {
  [GUIDE_KEYS.I]:
    "Este cuestionario tiene como objetivo ayudarnos a identificar si los trabajadores han sido sujetos a acontecimientos traumáticos severos.",
  [GUIDE_KEYS.II]: "",
  [GUIDE_KEYS.III]: "",
};

/**
 * Titulo de barra de proceso
 */
export const SIDEBAR_TITLE: Record<string, string> = {
  [GUIDE_KEYS.I]: "Proceso",
  [GUIDE_KEYS.II]: "Barra de proceso respondido",
  [GUIDE_KEYS.III]: "Barra de proceso respondido",
};

/**
 * Variables almacenadas en el localStorage
 */

export const LOCAL_STORAGE = {
  DATOS_TRABAJADOR: "datos-trabajador",
};
